/*
 * @Author       : Lobin
 * @Date         : 2018-11-04 23:05:03
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2022-06-24 16:44:52
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import routes from './routes'
import nprogress from 'nprogress'

nprogress.configure({ trickle: true,easing: 'ease', speed: 500 });
const meta = { requiresAuth:true }
const router = new Router({
	mode: 'history',
	routes: [
    {
			path: '/',
			meta: { name: '主页'},
			name: 'default',
			redirect: { path: '/home/dashboard' }
		},
		{
			path:'/login',
			meta: { name: '登陆'},
			name:'login',
			component: () => import('../views/login.vue')
		},
		// ...routes
	]
})
/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach((to, from, next) => {
	nprogress.start();
	// 验证当前路由所有的匹配中是否需要有登陆验证的
	if (to.matched.some(r => r.meta.requiresAuth)) {
		// 请根据自身业务需要修改
		const token = window.localStorage.getItem('token');
		if (token && token !== 'undefined') {
			next()
		} else {
			// 没有登陆的时候跳转到登陆界面
			next({
				name: 'login'
			})
		}
	} else {
		// 不需要身份校验 直接通过
		next()
	}
})

router.afterEach(to => {
	const app = router.app
	const { name, params, query } = to
	nprogress.done();
})
export const setRoute = (permisionKeys: Array<string>) => {
	const constRouter = router.options.routes;
	router.options.routes = [];
	const resultRoute: any = [];
	routes.forEach((currentValue) => {
		if (permisionKeys.includes(currentValue.name)) {
		  if (currentValue.children && currentValue.children.length > 0) {
			currentValue.children = currentValue.children.filter((item) => permisionKeys.includes(item.name));
		  }
		  resultRoute.push(currentValue);
		}
	});
	router.addRoutes(resultRoute);
	router.options.routes = constRouter ? constRouter.concat(resultRoute) : resultRoute;
}
export default router

